// const exportUrl="http://localhost:8000/";
const exportUrl="https://microfinance.goldenglobal.in/backend/public/";

export default exportUrl;